/*global jest*/
/* eslint-disable */
// @ts-nocheck
import { ConnectHost } from '../ConnectHost';
import { MockSimpleXdmExtension } from './MockSimpleXdmExtension';

/**
 * This class provides a mock implementation of ConnectHost.
 */
export class MockConnectHost implements ConnectHost {
	onIframeEstablished: jest.Mock<any, any, any> = jest.fn();
	offIframeEstablished: jest.Mock<any, any, any> = jest.fn();
	onIframeUnload: jest.Mock<any, any, any> = jest.fn();
	offIframeUnload: jest.Mock<any, any, any> = jest.fn();
	createExtension: jest.Mock<MockSimpleXdmExtension, [params: any], any> = jest.fn((params) => {
		let val = new MockSimpleXdmExtension();
		val.iframeAttributes.src = params.url;
		return val;
	});
	destroy: jest.Mock<any, any, any> = jest.fn();
	getContentResolver: jest.Mock<any, any, any> = jest.fn();
	hasJwt: jest.Mock<any, any, any> = jest.fn();
	isJwtExpired: jest.Mock<any, any, any> = jest.fn();
}
